<template>
    <div class="content">
        <ContentLoader :isDisplay="!contentReady" />
        <section v-if="contentReady">
            <LayoutHeader :fields="fields" />
            <slot />
            <LayoutFooter />
        </section>
        <ModalLogin />
        <ModalRegister />
        <ModalForgetPassword />
        <ModalFullPicture />
        <ModalLanguage />
    </div>
</template>

<script>
import LayoutHeader from "@/components/LayoutHeader";
import LayoutFooter from "@/components/LayoutFooter";
import ContentLoader from '@/weact/components/ContentLoader';

export default {
    components: {
        LayoutHeader,
        LayoutFooter,
        ContentLoader
    },
    data() {
        return {
            contentReady: false,
            fields: {}
        }
    },
    created() {
        let page = this;

        setTimeout(function(){
            page.getContent();
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        getContent() {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {};

            this.$WeHelper.postAPI(apiURL, '/api/user/authen-user', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                this.fields = response.data;
                this.$PPlusEngine.IsAuthen = this.fields.user.isAuthen;
                this.contentReady = true;
            });
        }
    }
};
</script>